import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FiltersState {
  pages: Record<string, Record<string, any>>;
}

const initialState: FiltersState = {
  pages: {},
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setPageFilters(
      state,
      action: PayloadAction<{ pageKey: string; filters: Record<string, any> }>,
    ) {
      const { pageKey, filters } = action.payload;
      state.pages[pageKey] = {
        ...(state.pages[pageKey] || {}),
        ...filters,
      };
    },
    clearPageFilters(state, action: PayloadAction<string>) {
      delete state.pages[action.payload];
    },
    clearAllFilters(state) {
      state.pages = {};
    },
  },
});

export const { setPageFilters, clearPageFilters, clearAllFilters } =
  filtersSlice.actions;
export default filtersSlice.reducer;
